// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PersonalAgreement_privacyPolicy__lClcU"};